"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importDefault(require("react"));
const Slider_styled_1 = require("./Slider.styled");
const react_slider_1 = __importDefault(require("react-slider"));
const Text_1 = require("../Typography/Text");
const Minus_1 = require("../icons/Minus/Minus");
const Plus_1 = require("../icons/Plus/Plus");
const Color_enum_1 = require("../../constants/Color.enum");
const Slider = ({ minValue = 0, maxValue = 100, handleChange, unit, value, disabled, label, dataTestId, step = 1, trackBackgroundColor = Color_enum_1.Color.Variant_1, valueModify = (value) => value, }) => {
    const showIncreaseControl = value < maxValue;
    return (react_1.default.createElement(Slider_styled_1.SliderWrapperStyled, { "data-test": "slider", "data-test-id": dataTestId, disabled: disabled, trackBackgroundColor: trackBackgroundColor },
        label && (react_1.default.createElement("div", { className: "mr-20 w-40" },
            react_1.default.createElement(Text_1.TextXS, null, label))),
        react_1.default.createElement(react_slider_1.default, { withTracks: true, className: "horizontal-slider", trackClassName: "track", max: maxValue, min: minValue, onChange: handleChange, value: value, step: step, renderThumb: (props) => (react_1.default.createElement(Slider_styled_1.SliderThumb, Object.assign({ "data-test": "slider-thumb" }, props, { as: undefined }),
                react_1.default.createElement(Slider_styled_1.ControlStyled, { "data-test": "slider-decrease", onClick: () => handleChange(value - step), hidden: value <= minValue },
                    react_1.default.createElement(Minus_1.MinusIcon, null)),
                react_1.default.createElement(Slider_styled_1.ValueWrapper, { "data-test": "slider-value" },
                    react_1.default.createElement(Slider_styled_1.ValueStyled, null,
                        " ",
                        valueModify(value),
                        " "),
                    react_1.default.createElement(Slider_styled_1.UnitStyled, { className: "ml-2" }, unit)),
                react_1.default.createElement(Slider_styled_1.ControlStyled, { "data-test": "slider-increase", onClick: () => handleChange(value + step), hidden: !showIncreaseControl },
                    react_1.default.createElement(Plus_1.PlusIcon, null)))) })));
};
exports.Slider = Slider;
